// Arrow-button paging for the Food Categories carousel.
// Scrolls the viewport by `clientWidth` per click, smoothly.
// Disables the arrows at the start / end of the track.

(function () {
    function init() {
        document.querySelectorAll('.home-cats').forEach(setup);
    }

    function setup(section) {
        const viewport = section.querySelector('[data-cats-viewport]');
        const prev = section.querySelector('[data-cats-prev]');
        const next = section.querySelector('[data-cats-next]');
        if (!viewport) return;

        const update = () => {
            const max = viewport.scrollWidth - viewport.clientWidth - 2;
            if (prev) prev.disabled = viewport.scrollLeft <= 2;
            if (next) next.disabled = viewport.scrollLeft >= max;
        };

        if (prev) prev.addEventListener('click', () => {
            viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', () => {
            viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
